const navigation = {
  sites: 'Sites',
  profile: 'Profile',
  payment: 'Payment',
  extensions: 'Extensions',
  invoices: 'Invoice',
  forecast: 'Forecast',
  toolbox: 'Toolbox',
  support: 'Support',
  logout: 'Logout',
  logoutinas: 'Logged in as ',
  updates: 'Updates',
  log: 'Activity-Log',
  remote: 'Get Remotemonkey',
  documentation: 'Documentation',
  users: 'Users',
  dpainfo: 'GDPR Information',
  settings: 'Settings',
  togglemenu: 'Toggle Menu'
}

export default navigation
